import { render, staticRenderFns } from "./MenuGrid.vue?vue&type=template&id=481efe9c"
import script from "./MenuGrid.vue?vue&type=script&lang=js"
export * from "./MenuGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports